import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import moment from 'moment';

export default {
    components: {},
    data() {
        return {
            is_show: true,

            seconds_original: 0,
            seconds_variety: 0,

            timer: {
                id_setInterval: null,
            },
        }
    },
    computed: {
        show_minutes() {
            const __this = this;
            let m = moment.duration(__this.seconds_variety, `seconds`).minutes();
            m = m.toString().padStart(2, `0`);
            return m;
        },
        show_seconds() {
            const __this = this;
            let s = moment.duration(__this.seconds_variety, `seconds`).seconds();
            s = s.toString().padStart(2, `0`);
            return s;
        },
    },
    methods: {
        init(pParameter) {
            if (!pParameter) pParameter = {};
            const seconds = pParameter.seconds || 0;
            const time_is_running_out_event_handler = pParameter.time_is_running_out_event_handler;

            const __this = this;
            __this.seconds_original = seconds;
            __this.seconds_variety = seconds;

            clearInterval(__this.timer.id_setInterval);
            __this.timer.id_setInterval = setInterval(function () {
                __this.seconds_variety = __this.seconds_variety - 1;
                if (__this.seconds_variety <= 0) {
                    clearInterval(__this.timer.id_setInterval);
                    if (_.isFunction(time_is_running_out_event_handler)) {
                        time_is_running_out_event_handler();
                    }
                }
            }, 1 * 1000);
        },

        show() {
            const __this = this;
            __this.is_show = true;
        },

        hide() {
            const __this = this;
            __this.is_show = false;
        },
    },
    created() {
        const __this = this;
    },
}
